<template>
    <Card>
        <div class="top-line search-line">
            <span class="sk-title-small content-center" style="flex: 1">待处理</span>
        </div>
        <div class="split-line"></div>
        <div class="top-line search-line msg-row">
            <el-row>
                <el-col :span="5" class="cell-padding">
                    <span class="sk-title-small">人流阈值</span>
                    <div class="ly-c-container layout-totalnum">
                        <div class="ly-c-container-main center-text" style="line-height: 80px">
                            <span class="total-num1">{{ flowMsgList1.length }}</span>
                        </div>
                        <div class="ly-c-container-v">
                            <div class="ly-c-container-main center-text">
                                <div class="ly-c-container">
                                    <span class="total-num2">
                                        {{ flowMsgList1.filter((r) => r.MsgLevel == 3).length }}
                                    </span>
                                    <span class="total-desc">严重</span>
                                </div>
                            </div>
                            <div class="split-line-column"></div>
                            <div class="ly-c-container-main center-text">
                                <div class="ly-c-container">
                                    <span class="total-num3">{{ flowMsgList1.filter((r) => r.MsgLevel == 1 || r.MsgLevel == 2).length }}</span>
                                    <span class="total-desc">一般</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </el-col>
                <el-col :span="7" class="cell-padding">
                    <el-radio-group v-model="msgType1" size="mini">
                        <el-radio-button label="1">待处理</el-radio-button>
                        <el-radio-button label="2">已处理</el-radio-button>
                    </el-radio-group>
                    <div class="ly-c-container" v-if="msgType1 == '1'">
                        <span v-if="flowMsgList1.length == 0">暂无内容</span>
                        <ul class="msg-list scroll-container-no" v-if="flowMsgList1.length > 0">
                            <li v-for="(item, index) in flowMsgList1" :key="index">
                                <div>
                                    <span class="tag1" v-if="item.MsgLevel == 3"> 【严重】 </span>
                                    <span class="tag2" v-if="item.MsgLevel != 3"> 【一般】 </span>
                                    <span>{{ item.MsgContent }} </span>
                                </div>
                                <div class="button">
                                    <el-button type="danger" size="mini" @click="showDialog(item, 1)"> 处理 </el-button>
                                </div>
                            </li>
                        </ul>
                    </div>
                    <div class="ly-c-container" v-if="msgType1 == '2'">
                        <span v-if="flowMsgList2.length == 0">暂无内容</span>
                        <ul class="msg-list scroll-container-no" v-if="flowMsgList2.length > 0">
                            <li v-for="(item, index) in flowMsgList2" :key="index">
                                <div>
                                    <span class="tag1" v-if="item.MsgLevel == 3"> 【严重】 </span>
                                    <span class="tag2" v-if="item.MsgLevel != 3"> 【一般】 </span>
                                    <span>{{ item.MsgContent }} </span>
                                </div>
                            </li>
                        </ul>
                    </div>
                </el-col>
                <el-col :span="5" class="cell-padding">
                    <span class="sk-title-small">设备信息</span>
                    <div class="ly-c-container layout-totalnum">
                        <div class="ly-c-container-main center-text" style="line-height: 80px">
                            <span class="total-num1">
                                {{ deviceList.length }}
                            </span>
                        </div>
                        <div class="ly-c-container-v">
                            <div class="ly-c-container-main center-text">
                                <div class="ly-c-container">
                                    <span class="total-num3">
                                        {{ onLine }}
                                    </span>
                                    <span class="total-desc">在线</span>
                                </div>
                            </div>
                            <div class="split-line-column"></div>
                            <div class="ly-c-container-main center-text">
                                <div class="ly-c-container">
                                    <span class="total-num2">
                                        {{ offLine }}
                                    </span>
                                    <span class="total-desc">离线</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </el-col>
                <el-col :span="7" class="cell-padding">
                    <el-radio-group v-model="msgType2" size="mini">
                        <el-radio-button label="1">待处理</el-radio-button>
                        <el-radio-button label="2">已处理</el-radio-button>
                    </el-radio-group>
                    <div class="ly-c-container" v-if="msgType2 == '1'">
                        <span v-if="deviceMsgList1.length == 0">暂无内容</span>
                        <ul class="msg-list scroll-container-no" v-if="deviceMsgList1.length > 0">
                            <li v-for="(item, index) in deviceMsgList1" :key="index">
                                <div>
                                    <span>{{ item.MsgContent }} </span>
                                </div>
                                <div class="button">
                                    <el-button type="danger" size="mini" @click="showDialog(item, 2)"> 处理 </el-button>
                                </div>
                            </li>
                        </ul>
                    </div>
                    <div class="ly-c-container" v-if="msgType2 == '2'">
                        <span v-if="deviceMsgList2.length == 0">暂无内容</span>
                        <ul class="msg-list scroll-container-no" v-if="deviceMsgList2.length > 0">
                            <li v-for="(item, index) in deviceMsgList2" :key="index">
                                <div>
                                    <span>{{ item.MsgContent }} </span>
                                </div>
                            </li>
                        </ul>
                    </div>
                </el-col>
            </el-row>
        </div>
        <el-dialog v-model="isShowDialog" v-if="isShowDialog" title="处理消息" width="30%" :before-close="handleClose">
            <span>实体名称：{{ entityInfo.EntityName }} </span><br />
            <span>联系人：{{ entityInfo.Linkman }} </span><br />
            <span>联系电话：{{ entityInfo.Phone }} </span><br />
            <template #footer>
                <span class="dialog-footer">
                    <el-button @click="isShowDialog = false">取消</el-button>
                    <el-button type="primary" @click="processMsg">确定处理</el-button>
                </span>
            </template>
        </el-dialog>
    </Card>
</template>
<script>
export default {
    name: "MessageBar",
    data() {
        return {
            msgType1: "1",
            msgType2: "1",
            flowMsgList1: [],
            flowMsgList2: [],
            deviceMsgList1: [],
            deviceMsgList2: [],
            deviceList: [],
            onLine: 0,
            offLine: 0,
            entityInfo: {},
            isShowDialog: false,
            showType: 1,
            showMsgID: "",
        };
    },
    created() {
        this.loadDevMsg1();
        this.loadDevMsg2();
        this.loadFlowWarnMsg1();
        this.loadFlowWarnMsg2();
        this.GetDeviceStates();
    },
    methods: {
        showDialog(item, type) {
            this.showMsgID = item.MsgID;
            this.showType = type;
            if (item.EntityID) {
                this.$ajax.post("/Entity/GetEntity?id=" + item.EntityID).then((res) => {
                    this.entityInfo = { ...res.Data };
                    this.isShowDialog = true;
                });
            } else {
                this.processMsg();
            }
        },
        processMsg() {
            this.$myConfirm().then(() => {
                if (this.showType == 1) {
                    this.processMsg1(this.showMsgID);
                } else {
                    this.processMsg2(this.showMsgID);
                }
            });
        },
        processMsg1(id) {
            this.$ajax.post("/Msg/ProcessMsg?id=" + id).then((res) => {
                this.$message.success("操作成功");
                this.loadFlowWarnMsg1();
                this.loadFlowWarnMsg2();
                this.isShowDialog = false;
            });
        },
        processMsg2(id) {
            this.$ajax.post("/Msg/ProcessMsg?id=" + id).then((res) => {
                this.$message.success("操作成功");
                this.loadDevMsg1();
                this.loadDevMsg2();
                this.isShowDialog = false;
            });
        },

        loadDevMsg1() {
            this.$ajax.post("/Msg/GetDeviceMsg", { PageIndex: 1, PageSize: 100 }).then((r) => {
                this.deviceMsgList1 = r.Data;
            });
        },
        loadDevMsg2() {
            this.$ajax.post("/Msg/GetDeviceMsgProcessed", { PageIndex: 1, PageSize: 100 }).then((r) => {
                this.deviceMsgList2 = r.Data;
            });
        },
        loadFlowWarnMsg1() {
            this.$ajax.post("/Msg/GetFlowWarnMsg", { PageIndex: 1, PageSize: 100 }).then((r) => {
                this.flowMsgList1 = r.Data;
            });
        },
        loadFlowWarnMsg2() {
            this.$ajax.post("/Msg/GetFlowWarnMsgProcessed", { PageIndex: 1, PageSize: 100 }).then((r) => {
                this.flowMsgList2 = r.Data;
            });
        },
        GetDeviceStates() {
            this.$ajax.post("/Entity/GetDeviceStates", { PageIndex: 1, PageSize: 1000 }).then((r) => {
                this.onLine = r.Data.OnLine;
                this.offLine = r.Data.OffLine;
                this.deviceList = r.Data.ListData;
            });
        },
    },
};
</script>
<style scoped>
.msg-row {
    height: 300px;
    margin-bottom: 20px;
}
.layout-totalnum {
    height: 160px;
    margin-top: 30px;
}
.total-num1 {
    color: #2363f6;
    font-weight: bolder;
    font-size: 32px;
}
.total-num2 {
    font-size: 30px;
    color: #dc6f69;
}
.total-num3 {
    font-size: 30px;
    color: #5bc396;
}
.total-desc {
    color: #888;
    font-size: 16px;
}
.center-text {
    text-align: center;
}
.split-line-column {
    border-left: 1px solid #f1f1f1;
    border-right: 1px solid #f5f5f5;
    flex: none;
    width: 0px;
    height: 60px;
    margin-top: 10px;
}
ul.msg-list {
    width: 100%;
    height: 200px;
    overflow: auto;
    overflow-x: hidden;
    box-sizing: border-box;
}
ul.msg-list li {
    width: 100%;
    height: 40px;
    line-height: 40px;
    box-sizing: border-box;
    overflow: hidden;
    display: flex;
    flex-direction: row;
    color: #333;
    font-size: 14px;
}
ul.msg-list li span.tag1 {
    color: #dc6f69;
}
ul.msg-list li span.tag2 {
    color: #ffa800;
}
ul.msg-list li > div {
    flex: 1;
}
ul.msg-list li > div.button {
    flex: none;
    width: 100px;
}
.cell-padding {
    padding: 20px;
}
</style>
